import CardDetailsPanel from './CardDetailsPanel';
export default CardDetailsPanel;
